import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {RouteRequestsService} from "../../../routes/services/routes-requests.service";
import {RoutesListPayloadModel} from "../../../routes/models/routes-list-payload.model";
import {RouteStatusEnum} from "../../../routes/enums/route-status.enum";
import {RouteModel} from "../../../routes/models/route.model";
import {RoutesViewSettingsRoutesModel} from "../../../routes/models/routes-view-settings.model";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {AgentStatusType} from "../../types/agentStatus.type";

export class AgentRoutesDialogViewComponent implements IController {
  agentIds: string[];
  onAssign: Function;

  public routes: RouteModel[];
  public filteredRoutes: RouteModel[];
  public selectedRoutes?: RouteModel[];
  public assignData: any;
  public filteredassignData: any;
  public agentsQueryString: string;
  public routesQueryString: string;
  public selectedAgentStatuses: any[] = [];
  public agentTags: any[] = [];
  public agentStatuses: AgentStatusType[];
  public settings: RoutesViewSettingsRoutesModel = {
    columns: {
      id: true,
      status: true,
      skills: false,
      resource: true,
      plateNumber: false,
      distance: false,
      duration: true,
      agent: true,
      assistant: false,
      price: false,
      timeWindow: true,
      services: true,
      tasksCount: false,
      accounts: false,
      accountsExternalIds: false,
      trips: false,
      tags: false,
      proNumber: false,
      referenceIds: false,
      pickingHour: false,
      pickupStops: false,
      destinationStops: false,
      progress: false,
      relations: false
    },
    load: {
      weight:  false,
      volume:  false,
      packages:  false,
      value:  false,
      spots:  false,
      pallets: false
    },
    capacity: {
      weight:  false,
      volume:  false,
      pallets: false
    }
  };
  public agentsSettings: any;
  public selectedKeys: Object = {};
  public loadingAssignData: boolean = false;

  /* @ngInject */
  constructor(private routeRequestsService: RouteRequestsService,
              private deliveriesRequestsService: DeliveriesRequestsService,
              private splitService: SplitService) {
    this.agentsSettings = this.splitService.getSiteServicesAssignAgentSettings();
    this.agentStatuses = Object.values(AgentStatusType);
  }

  $onInit() {
    this._initRoutes();
  }

  $onChanges(changes) {
    // if (changes.serviceIds && !changes.serviceIds.isFirstChange()) {
    //   this.$onInit();
    // }
  };

  onRoutesQueryChange(query) {
    this.routesQueryString = query;
    this._setFilteredRoutes();
  }

  onAgentQueryChange(query) {
    this.agentsQueryString = query;
    this._setFilteredAgents();
  }

  onTagChange(tagNames) {
    this.agentTags = tagNames;
    this._setFilteredAgents();
  }

  onChangeAgentStatus(statuses) {
    this.selectedAgentStatuses = statuses;
    this._setFilteredAgents();
  }

  onRoutesSettingsChange(settings: RoutesViewSettingsRoutesModel) {
    this.settings = settings;
  }

  onAgentsViewSettingsChange(settings) {
    this.agentsSettings = settings;
  }

  onToggleSelectAllRoutes() {
    if (_.isEmpty(this.selectedKeys)) {
      this.routes.forEach((r) => {
        this.selectedKeys[r.id] = r;
      })
    } else {
      this.selectedKeys = {};
    }
    this._setSelectedRoutes();
    this._setAssignData();
  }

  onSelectRoute(route) {
    if (!!this.selectedKeys[route.id]) {
      _.unset(this.selectedKeys, route.id);
    } else {
      this.selectedKeys[route.id] = route;
    }
    this._setSelectedRoutes();
    this._setAssignData();
  }

  private _initRoutes() {
    this.routes = undefined;

    const query: RoutesListPayloadModel = {
      agentIds: this.agentIds,
      status: [RouteStatusEnum.Started, RouteStatusEnum.Assigned]
    }
    this.routeRequestsService.getRoutesList(query)
      .then((routes: RouteModel[]) => {
        this.routes = routes;
        this._setFilteredRoutes();
      })
  }

  private _setFilteredRoutes() {
    if (!this.routesQueryString) {
      this.filteredRoutes = angular.copy(this.routes);
    } else {
      const filteredRoutes = [];

      this.routes.forEach((r) => {
        if (_.includes(JSON.stringify(r).toLowerCase(), this.routesQueryString.toLowerCase())) {
          filteredRoutes.push(r)
        }
      })
      this.filteredRoutes = filteredRoutes;
    }
  }

  private _setFilteredAgents() {
    const filteredAgents = _.filter(this.assignData.list, (item) => {
      return (!this.selectedAgentStatuses?.length || _.includes(this.selectedAgentStatuses, item.agent.status)) &&
      (!this.agentTags?.length || this.agentTags.some(t => item.agent.tags?.includes(t))) &&
      (!this.agentsQueryString || _.includes(JSON.stringify(item.agent).toLowerCase(), this.agentsQueryString.toLowerCase()))
    });

    this.filteredassignData = angular.copy(this.assignData);
    this.filteredassignData.list = filteredAgents;
  }

  private _setSelectedRoutes() {
    this.selectedRoutes = [];
    _.forOwn(this.selectedKeys, (r:any, key) => {
      this.selectedRoutes.push(r);
    })
  }

  private _setAssignData() {
    this.assignData = undefined;
    this.filteredassignData = undefined;

    if (!this.selectedRoutes.length) {
      return;
    }

    this.loadingAssignData = true;
    const aggregatedServiceIdList = _.uniq(_.flatMap(this.selectedRoutes, 'serviceIdList'));
    this.deliveriesRequestsService.getAssignAgentData(aggregatedServiceIdList, 'Location', this.agentsQueryString)
      .then((data) => {
        this.assignData = data;
        this._setFilteredAgents();
      })
      .finally(() => {
        this.loadingAssignData = false;
      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentRoutesDialogView', {
    bindings: {
      agentIds: '<',
      onAssign: '&'

    },
    template: require('./agent-routes-dialog-view.html').default,
    controller: AgentRoutesDialogViewComponent
  });
